import axios, {
  AxiosResponse,
} from "axios";
import getConfig from "../../config/configUtil";

const conf = getConfig;

export default class AdminReportsService { 
  async downloadFile(type: string, fileName: string): Promise<void> {
    try {
      const response: AxiosResponse = await axios.get(
        conf.BACKEND + "admin/" + type + "/report",
        {
          responseType: "blob",
        }
      );

      const url = window.URL.createObjectURL(new Blob([response.data]));

      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", fileName);
      document.body.appendChild(link);
      link.click();
      link.remove();
    } catch (error) {
      console.log(error);
      throw new Error("Failed to download file");
    }
  }
}